import { render, staticRenderFns } from "./ReportMenu.vue?vue&type=template&id=a0fdcfa2"
import script from "./ReportMenu.vue?vue&type=script&lang=js"
export * from "./ReportMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports